import React from "react";
import "../styles/layout/Header.scss";
import { Avatar } from "primereact/avatar";
import { Dropdown } from "primereact/dropdown";
import { useLanguage } from "../contexts/LanguageContext";

const Header: React.FC = () => {
  const { selectedLanguage, setSelectedLanguage } = useLanguage();

  const languages = [
    { name: "PHP", code: "php" },
    { name: "Javascript", code: "javascript" },
    { name: "Python", code: "python" },
  ];

  const handleLanguageChange = (e: any) => {
    setSelectedLanguage(e.value);
  };

  return (
    <header className="header">
      <div className="header-search flex align-items-center">
        <p>Language: </p>
        <Dropdown
          value={selectedLanguage}
          options={languages}
          onChange={handleLanguageChange}
          optionLabel="name"
          optionValue="code"
          placeholder="Select a Language"
          className="ml-3 flex align-items-center"
          style={{ width: "240px", height: "40px", fontSize: "5px" }}
        />
      </div>
      <div className="flex header-icons align-content-center flex-wrap">
        <i className="flex align-items-center justify-content-center bi bi-box"></i>
        <i className="flex align-items-center justify-content-center bi bi-bell"></i>
        <Avatar
          label="V"
          size="large"
          style={{ backgroundColor: "#2196F3", color: "#ffffff" }}
          shape="circle"
        />
      </div>
    </header>
  );
};

export default Header;
